import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

export default class extends Controller {
  static values = { points: Array }

  connect() {
    const pts = this.pointsValue
    if (!pts.length) return

    const first = [pts[0].lat, pts[0].lng]
    const map = L.map(this.element).setView(first, 15)

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
    }).addTo(map)

    const latlngs = pts.map(p => [p.lat, p.lng])

    pts.forEach((p) => {
      const marker = L.marker([p.lat, p.lng]).addTo(map)
      marker.bindPopup(`<b>Time:</b> ${p.t}`)
    })

    if (latlngs.length > 1) {
      L.polyline(latlngs, { weight: 4 }).addTo(map)
      map.fitBounds(latlngs)
    }
  }
}
